export const fileToBase64 = (file) => {
  const recreatedFile = new File([file], file.name, {
    lastModified: file.lastModified,
    type: file.type,
  })
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => {
      resolve(reader.result)
    }
    reader.onerror = () => {
      reject(reader.error)
    }
    reader.readAsDataURL(recreatedFile)
  })
}